import { CnRangeDatePickerPro, CnMonthPickerPro, CnYearPickerPro, CnWeekPickerPro, CnQuarterPickerPro, } from './view';
import { CnDatePicker, CnDatePickerPro } from './view/cn-date-picker-pro';
/**
 * @deprecated 请使用 CnRangeDatePickerPro 替换
 */
var CnDateRangePickerPro = CnRangeDatePickerPro;
CnDateRangePickerPro.displayName = 'CnDateRangePickerPro';
export { CnDatePickerPro, CnDatePicker, CnMonthPickerPro, CnYearPickerPro, CnWeekPickerPro, CnQuarterPickerPro, CnRangeDatePickerPro, CnDateRangePickerPro, };
